type PropsT = {
  className?: string
  strokeColor?: string
}

// Outline gift box with a "+" badge (AI-1439 design asset). Stroke follows
// currentColor so it tracks the button's text color, including disabled.
const GiftAdd = (props: PropsT) => {
  const { className, strokeColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="1.76"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="gift-add-icon"
    >
      <path d="M10.92 7.40043V19.7204M10.92 7.40043C10.6017 6.0887 10.0536 4.96724 9.34721 4.18237C8.64082 3.39749 7.80892 2.98559 6.96 3.00038C6.37652 3.00038 5.81694 3.23217 5.40436 3.64475C4.99178 4.05733 4.76 4.61691 4.76 5.20038C4.76 5.78386 4.99178 6.34344 5.40436 6.75602C5.81694 7.1686 6.37652 7.40038 6.96 7.40038M10.92 7.40043C11.2383 6.0887 11.7864 4.96724 12.4928 4.18237C13.1992 3.39749 14.0311 2.98559 14.88 3.00038C15.4635 3.00038 16.0231 3.23217 16.4356 3.64475C16.8482 4.05733 17.08 4.61691 17.08 5.20038C17.08 5.78386 16.8482 6.34344 16.4356 6.75602C16.0231 7.1686 15.4635 7.40038 14.88 7.40038M17.96 10.9204C18.446 10.9204 18.84 10.5264 18.84 10.0404V8.28043C18.84 7.79442 18.446 7.40043 17.96 7.40043H3.88C3.39399 7.40043 3 7.79442 3 8.28043V10.0404C3 10.5264 3.39399 10.9204 3.88 10.9204M17.96 10.9204H3.88M17.96 10.9204L17.96 13.5M3.88 10.9204V17.9604C3.88 18.4272 4.06543 18.8749 4.39549 19.2049C4.72556 19.535 5.17322 19.7204 5.64 19.7204H12.92" />
      <path d="M14.9199 18.8672H20.6543M17.7871 16V21.7344" />
    </svg>
  )
}

export default GiftAdd
